import * as _ from 'lodash';
var selectFilters = [
    {
        type: 'equal',
        label: 'Is equal to',
        filter: function (value, filter) { return _.isEqual(value, filter); }
    },
    {
        type: 'notEqual',
        label: 'Is not equal to',
        filter: function (value, filter) { return !_.isEqual(value, filter); }
    },
    {
        type: 'contain',
        label: 'Contains',
        filter: function (value, filter) {
            if (_.isArray(value)) {
                return filter.every(function (f) { return value.includes(f); });
            }
            return _.isEqual(value, filter);
        }
    },
    {
        type: 'notContain',
        label: 'Does not contain',
        filter: function (value, filter) {
            if (_.isArray(value)) {
                return filter.every(function (f) { return !value.includes(f); });
            }
            return !_.isEqual(value, filter);
        }
    },
    {
        type: 'gt',
        label: 'Greater than',
        filter: function (value, filter) { return value > filter; }
    },
    {
        type: 'gte',
        label: 'Greater than or equal to',
        filter: function (value, filter) { return value >= filter; }
    },
    {
        type: 'lt',
        label: 'Less than',
        filter: function (value, filter) { return value < filter; }
    },
    {
        type: 'lte',
        label: 'Less than or equal to',
        filter: function (value, filter) { return value <= filter; }
    },
];
var checkboxFilters = [
    {
        type: 'equal',
        label: 'Is equal to',
        filter: function (value, filter) { return _.isEqual(value, filter); }
    }
];
var selectboxesFilters = [
    {
        type: 'equal',
        label: 'Is equal to',
        filter: function (value, filter) { return _.isEqual(value, filter); }
    },
    {
        type: 'contain',
        label: 'Contains',
        filter: function (value, filter) { return value.toString().includes(filter.toString()); }
    },
];
var dayTimeFilters = [
    {
        type: 'equal',
        label: 'Is equal to',
        filter: function (value, filter) { return _.isEqual(value, filter); }
    },
    {
        type: 'notEqual',
        label: 'Is not equal to',
        filter: function (value, filter) { return !_.isEqual(value, filter); }
    },
    {
        type: 'gt',
        label: 'Is after',
        filter: function (value, filter) { return value > filter; }
    },
    {
        type: 'lt',
        label: 'Is before',
        filter: function (value, filter) { return value < filter; }
    },
];
var surveyFilters = [
    {
        type: 'contain',
        label: 'Contains',
        filter: function (value, filter) { return value.toString().includes(filter.toString()); }
    }
];
var signatureFilters = [
    {
        type: 'matches',
        label: 'Is equal to',
        filter: function (value, filter) { return value.toString().match(new RegExp(filter, 'gi')); }
    }
];
var fileFilters = [
    {
        type: 'exists',
        label: 'Uploaded',
        filter: function (value, filter) { return _.isEqual(!!value, filter); }
    }
];
var radioFilters = [
    {
        type: 'equal',
        label: 'Is equal to',
        filter: function (value, filter) { return _.isEqual(value, filter); }
    },
    {
        type: 'notEqual',
        label: 'Is not equal to',
        filter: function (value, filter) { return !_.isEqual(value, filter); }
    },
];
var phoneFilters = [
    {
        type: 'equal',
        label: 'Is equal to',
        filter: function (value, filter) { return _.isEqual(value, filter); }
    },
    {
        type: 'notEqual',
        label: 'Is not equal to',
        filter: function (value, filter) { return !_.isEqual(value, filter); }
    },
    {
        type: 'startsWith',
        label: 'Starts with',
        filter: function (value, filter) { return value.toString().startsWith(filter.toString()); }
    },
    {
        type: 'contain',
        label: 'Contains',
        filter: function (value, filter) { return value.toString().includes(filter.toString()); }
    },
    {
        type: 'notContain',
        label: 'Does not contain',
        filter: function (value, filter) { return !value.toString().includes(filter.toString()); }
    },
    {
        type: 'endsWith',
        label: 'Ends with',
        filter: function (value, filter) { return value.toString().endsWith(filter.toString()); }
    },
    {
        type: 'matches',
        label: 'Matches (RegExp)',
        filter: function (value, filter) { return value.toString().match(new RegExp(filter, 'gi')); }
    }
];
export var filterByComponentType = {
    select: selectFilters,
    checkbox: checkboxFilters,
    selectboxes: selectboxesFilters,
    day: dayTimeFilters,
    survey: surveyFilters,
    signature: signatureFilters,
    file: fileFilters,
    radio: radioFilters,
    phoneNumber: phoneFilters,
    time: dayTimeFilters
};
